import React from "react";
import CaseCard from "./Components/CaseCard.js";
import WhiteButton from "../../../../Components/WhiteButton.js";
import { ArrowRight } from "lucide-react";
import SectionHeader from "../../../../Components/SectionHeader.js";
import { useNavigate } from "react-router-dom";
import HorizontalScrollSection from "../../../../Components/HorizontalScrollSection.js";

const WorkSection = () => {
  const navigate = useNavigate();
  const CasesList = [
    {
      title: "PREDICTIVE MEETS GENERATIVE",
      description: "Revolutionize Quote to Cash for Operational Excellence",
      imageURL: "/images/case-studies/4/case-image-0.jpeg",
    },
    {
      title: "AI DRIVEN HEALTH TECH HUB",
      description: "From Smarter Patient Care to Scalable Digital Solutions",
      imageURL: "/images/case-studies/7/case-image-5.jpeg",
    },
    {
      title: "FUTURE PROOFING WITH AI",
      description:
        "Building Scalable Strategies for Next Gen AI Ready Logistics Software Products",
      imageURL: "/images/case-studies/9/case-image-0.jpeg",
    },
  ];

  return (
    <section className="flex flex-col md:flex-row min-h-screen">
      <div className="text-white flex-1 flex flex-col">
        <main className="flex-1 flex flex-col items-center pt-[28%] md:py-[8%]">
          <SectionHeader
            childClassName="md:px-[16%] text-base md:text-lg"
            tagline="Case Studies"
            title={
              <div>
                AI Powered Transformations: <br />
                Real World Innovations
              </div>
            }
            description="See how cutting-edge Al solutions are solving complex challenges and driving business growth"
          />
          <div class="hidden md:grid justify-center md:grid-cols-3 gap-4 px-[3.5%] md:px-20 pb-12">
            {CasesList.slice(0, 3).map((offers) => (
              <CaseCard
                key={offers.title}
                title={offers.title}
                imageUrl={offers.imageURL}
                description={offers.description}
              />
            ))}
          </div>
          <WhiteButton
            className="hidden md:block"
            text="View more"
            icon={<ArrowRight />}
            onClick={() => navigate("/case-studies")}
          />
        </main>
        <HorizontalScrollSection
          buttonTitle="View more"
          onClick={() => navigate("/case-studies")}
          className="pb-[28%] md:hidden"
          child={CasesList.slice(0, 3).map((offers, index) => (
            <CaseCard
              key={`card-${offers.title}-${index}`}
              className={`inline-block min-w-[46vh] !h-[466px] `}
              title={offers.title}
              imageUrl={offers.imageURL}
              description={offers.description}
            />
          ))}
        />
      </div>
    </section>
  );
};

export default WorkSection;
